export const categories = [
  {
    slug: 'action',
    name: '动作游戏',
    description: '热血刺激的动作冒险游戏合集，包含格斗、射击、平台跳跃等多种类型',
    icon: 'ri-sword-line',
    imageSeq: 'cat-action',
    color: 'from-primary-500 to-primary-700',
  },
  {
    slug: 'rpg',
    name: '角色扮演',
    description: '沉浸式角色扮演游戏，体验丰富的剧情和角色成长系统',
    icon: 'ri-user-star-line',
    imageSeq: 'cat-rpg',
    color: 'from-accent-500 to-accent-700',
  },
  {
    slug: 'strategy',
    name: '策略游戏',
    description: '考验智力的策略游戏合集，包含回合制、即时战略、塔防等类型',
    icon: 'ri-brain-line',
    imageSeq: 'cat-strategy',
    color: 'from-secondary-500 to-secondary-700',
  },
  {
    slug: 'simulation',
    name: '模拟经营',
    description: '模拟真实世界的经营建造游戏，打造属于你的理想世界',
    icon: 'ri-building-2-line',
    imageSeq: 'cat-simulation',
    color: 'from-primary-500 to-accent-500',
  },
  {
    slug: 'casual',
    name: '休闲游戏',
    description: '轻松愉快的休闲小游戏，随时随地享受游戏乐趣',
    icon: 'ri-gamepad-line',
    imageSeq: 'cat-casual',
    color: 'from-accent-500 to-primary-500',
  },
  {
    slug: 'indie',
    name: '独立游戏',
    description: '独具创意的独立游戏精品，发现与众不同的游戏体验',
    icon: 'ri-lightbulb-flash-line',
    imageSeq: 'cat-indie',
    color: 'from-secondary-500 to-accent-500',
  },
];

export const categoryArticles: Record<string, {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  imageSeq: string;
  isHot: boolean;
}[]> = {
  action: [
    { slug: 'action-install-guide', title: '动作类游戏完整安装教程：从下载到运行一气呵成', excerpt: '详细介绍动作类游戏的下载安装全流程，包括系统要求检测、安装包验证、常见报错解决方案等实用技巧。', category: 'action', date: '2026-07-28', readTime: '8分钟', imageSeq: 'art-action-1', isHot: true },
    { slug: 'action-top10-free', title: '2026年必玩的十款免费动作游戏推荐', excerpt: '精心筛选十款高质量免费动作游戏，涵盖格斗、射击、平台跳跃等多种类型，每一款都值得下载体验。', category: 'action', date: '2026-07-20', readTime: '12分钟', imageSeq: 'art-action-2', isHot: true },
    { slug: 'action-safe-download', title: '动作游戏安全下载渠道大盘点，避开病毒陷阱', excerpt: '盘点可靠的游戏下载渠道，教你如何识别恶意软件、虚假安装包，确保每次下载都安全无忧。', category: 'action', date: '2026-07-15', readTime: '6分钟', imageSeq: 'art-action-3', isHot: false },
    { slug: 'action-controller-setup', title: '手柄连接与键位设置终极指南', excerpt: '从手柄驱动安装到游戏内键位映射，手把手教你配置最佳的操作体验，告别按键冲突烦恼。', category: 'action', date: '2026-07-10', readTime: '7分钟', imageSeq: 'art-action-4', isHot: false },
    { slug: 'action-performance-opt', title: '低配电脑也能流畅运行动作游戏的优化秘籍', excerpt: '通过画质调节、驱动优化、后台管理等方法，让低配置电脑也能畅玩大型动作游戏。', category: 'action', date: '2026-07-05', readTime: '9分钟', imageSeq: 'art-action-5', isHot: false },
  ],
  rpg: [
    { slug: 'rpg-install-tutorial', title: 'RPG游戏下载安装全攻略：从零开始的新手指南', excerpt: '面向RPG新手的完整教程，涵盖游戏平台注册、客户端下载、汉化补丁安装、存档管理等全部流程。', category: 'rpg', date: '2026-07-25', readTime: '10分钟', imageSeq: 'art-rpg-1', isHot: true },
    { slug: 'rpg-chinese-patch', title: 'RPG游戏汉化补丁安装方法详解', excerpt: '详细讲解各类RPG游戏的汉化补丁安装步骤，包括Steam版和独立版的区别处理，让你无障碍畅玩。', category: 'rpg', date: '2026-07-18', readTime: '8分钟', imageSeq: 'art-rpg-2', isHot: true },
    { slug: 'rpg-mod-guide', title: '精品RPG游戏MOD推荐与安装教程', excerpt: '精选多款热门RPG游戏的高质量MOD，提供详细的安装指南和兼容性说明，大幅提升游戏体验。', category: 'rpg', date: '2026-07-12', readTime: '15分钟', imageSeq: 'art-rpg-3', isHot: false },
    { slug: 'rpg-save-manager', title: 'RPG游戏存档管理与云同步方案', excerpt: '学会使用云存档功能保护游戏进度，掌握多设备间同步存档的技巧，再也不用担心数据丢失。', category: 'rpg', date: '2026-07-08', readTime: '6分钟', imageSeq: 'art-rpg-4', isHot: false },
  ],
  strategy: [
    { slug: 'strategy-beginner-guide', title: '策略游戏入门指南：从下载到上手只需要一小时', excerpt: '为策略游戏新手量身定制的入门教程，包含游戏选择建议、下载安装步骤、基础操作教学等内容。', category: 'strategy', date: '2026-07-26', readTime: '11分钟', imageSeq: 'art-strategy-1', isHot: true },
    { slug: 'strategy-free-top8', title: '2026年八款高质量免费策略游戏下载推荐', excerpt: '精选八款免费策略游戏，涵盖回合制、即时战略、塔防等多种子类型，款款精品不容错过。', category: 'strategy', date: '2026-07-19', readTime: '9分钟', imageSeq: 'art-strategy-2', isHot: false },
    { slug: 'strategy-online-setup', title: '策略游戏联机对战设置教程', excerpt: '详细教程教你如何设置策略游戏的联机对战功能，包括局域网和在线两种模式，和好友一起对战。', category: 'strategy', date: '2026-07-14', readTime: '7分钟', imageSeq: 'art-strategy-3', isHot: false },
  ],
  simulation: [
    { slug: 'sim-building-guide', title: '模拟经营游戏下载安装与起步攻略', excerpt: '从下载到上手，完整讲解模拟经营游戏的入门流程，包含推荐游戏列表和新手操作技巧。', category: 'simulation', date: '2026-07-27', readTime: '10分钟', imageSeq: 'art-sim-1', isHot: true },
    { slug: 'sim-dlc-guide', title: '模拟游戏DLC购买与安装全攻略', excerpt: '手把手教你如何安全购买和安装游戏DLC扩展包，避免买到不兼容或虚假的附加内容。', category: 'simulation', date: '2026-07-22', readTime: '8分钟', imageSeq: 'art-sim-2', isHot: false },
    { slug: 'sim-graphics-settings', title: '模拟经营游戏画质优化与性能平衡方案', excerpt: '在画质和性能之间找到最佳平衡点，通过合理的设置让模拟经营游戏既流畅又美观。', category: 'simulation', date: '2026-07-16', readTime: '7分钟', imageSeq: 'art-sim-3', isHot: false },
  ],
  casual: [
    { slug: 'casual-mobile-pc', title: '休闲游戏跨平台下载与数据同步教程', excerpt: '教你如何在手机和电脑之间同步休闲游戏进度，实现随时随地无缝切换的游玩体验。', category: 'casual', date: '2026-07-29', readTime: '6分钟', imageSeq: 'art-casual-1', isHot: true },
    { slug: 'casual-weekly-picks', title: '本周精选：五款解压休闲小游戏推荐', excerpt: '每周更新的休闲游戏推荐，精选五款轻松有趣的解压小游戏，适合碎片时间游玩。', category: 'casual', date: '2026-07-23', readTime: '5分钟', imageSeq: 'art-casual-2', isHot: false },
    { slug: 'casual-friends-play', title: '最适合和朋友一起玩的休闲联机游戏合集', excerpt: '收集了最适合多人联机的休闲游戏，包含本地双人和在线联机两种模式，聚会必备。', category: 'casual', date: '2026-07-17', readTime: '7分钟', imageSeq: 'art-casual-3', isHot: false },
  ],
  indie: [
    { slug: 'indie-discovery-guide', title: '独立游戏发现指南：如何找到隐藏的宝藏作品', excerpt: '分享独立游戏的发现渠道和筛选方法，帮你从海量作品中找到那些被埋没的精品独立游戏。', category: 'indie', date: '2026-07-30', readTime: '8分钟', imageSeq: 'art-indie-1', isHot: true },
    { slug: 'indie-platform-compare', title: '主流独立游戏平台下载对比：Steam vs itch.io vs Epic', excerpt: '全面对比三大独立游戏平台的下载体验、价格策略和社区生态，帮你选择最适合的平台。', category: 'indie', date: '2026-07-24', readTime: '11分钟', imageSeq: 'art-indie-2', isHot: false },
    { slug: 'indie-dev-interview', title: '对话独立游戏开发者：关于下载与分发的那些事', excerpt: '采访多位独立游戏开发者，了解游戏从开发到上架下载平台的幕后故事和行业洞察。', category: 'indie', date: '2026-07-21', readTime: '14分钟', imageSeq: 'art-indie-3', isHot: false },
  ],
};

export const allArticles = Object.values(categoryArticles).flat();

export const hotArticles = allArticles.filter((a) => a.isHot).slice(0, 6);

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export function getArticleBySlug(slug: string) {
  return allArticles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string) {
  return categoryArticles[categorySlug] || [];
}